import { Calendar } from "lucide-react";
import React from "react";
import Card from "../../Card/Card";
import { useAppSelector } from "src/redux/hooks";
import moment from "moment";
import StraightLineProgress from "../../StraightLineProgress";

const TimelineJourneyCard: React.FC = () => {
  const { patient } = useAppSelector((state) => state.auth);

  // const patientPlan = getActivePatientPlan(patientDetails?.data?.patient_plans)

  const expiry_date = patient?.data?.active_plan_details?.expiry_date; // patientPlan?.plan_end_date // '2025-04-13'
  const start_date = patient?.data?.active_plan_details?.start_date; // patientPlan?.plan_start_date // '2025-04-14'

  const informPlanExpiryDays = 10; // 10 days before plan expiry
  const expiryDate = expiry_date ? moment(expiry_date, "YYYY-MM-DD") : moment();
  const startDate = start_date ? moment(start_date, "YYYY-MM-DD") : moment();
  const currentDate = moment();

  // Calculate days completed and total days
  // const daysCompleted = 450; // for testing
  const daysCompleted = Math.max(
    0,
    Math.abs(currentDate.diff(startDate, "days"))
  );
  const totalDays = Math.max(1, Math.abs(expiryDate.diff(startDate, "days")));

  // Plan Expiry Status
  const planStatus =
    daysCompleted + informPlanExpiryDays >= totalDays
      ? "expiring"
      : daysCompleted >= totalDays
      ? "expired"
      : "active";

  // Calculate percentage (days completed / total days)
  const percentage = Math.min(
    100,
    Math.round((daysCompleted / totalDays) * 100)
  );

  return (
    <div className="mx-4">
      <Card
        title="Your Journey"
        icon={<Calendar className="w-4 h-4" />}
        description="See how far you have come"
      >
        <div>
          <div>
            <div className="flex items-center justify-between">
              <div className="text-sm text-[var(--card-subtitle-color)]">
                Progress
              </div>
              <div className="text-sm text-[var(--card-subtitle-color)]">
                {daysCompleted}/{totalDays} days
              </div>
            </div>
            <StraightLineProgress
              percentage={percentage}
              color={
                planStatus === "expired" || planStatus === "expiring"
                  ? "error"
                  : "primary"
              }
            />
          </div>

          {(planStatus === "expiring" || planStatus === "expired") && (
            <div>
              <div className="border-t border-[var(--card-border)] my-4"></div>
              <div className="flex items-center gap-2 text-sm border border-red-300 rounded-md bg-red-50 text-red-600 p-2">
                <div className="bg-red-500 w-[6px] h-[6px] rounded-full"></div>
                <div className="text-red-900">
                  {planStatus === "expiring"
                    ? "Program Ending soon."
                    : "Program Expired."}{" "}
                  {/* <button className="text-red-500 underline">
                    Extend plan
                  </button> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default TimelineJourneyCard;
